import Tournaments from './Tournaments';
export default Tournaments;
